<template>
  <div class="container">
<!--     <nav-bar rightShow="false" @leftClick="leftClick"></nav-bar> -->
    <div class="content">
      <div class="item" @click="update">
        <span class="f-l left">版本更新</span>
        <span class="f-l middle" v-if="isUpdate">NEW</span>
        <span class="f-r right">{{updateText}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import axios from 'axios'
import Common from '../../assets/js/common.js'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
export default {
  components: {
    NavBar
  },
  data () {
    return {
      isUpdate: false,
      upgrade: null,
      version: null,
      newVersion: null,
      deviceId: localStorage.getItem('max_device_id'),
      updateText: ''
    }
  },
  methods: {
    leftClick () {
      this.$router.back()
    },
    update () {
      this.$router.push({path: '/UpdateDetail', query: {upgrade: this.upgrade, version: this.version, newVersion: this.newVersion}})
    },
    getVersionInfo () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.get('/Calendar/api/version/get/version/info/?device_id=' + this.deviceId)
        .then(this.getVersionInfoSucc)
        .catch(this.getVersionInfoError)
      } else {
        axios.get(api + '/Calendar/api/version/get/version/info/?device_id=' + this.deviceId)
        .then(this.getVersionInfoSucc)
        .catch(this.getVersionInfoError)
      }
    },
    getVersionInfoSucc (res) {
      let _res = res.data
      this.toast.hide()
      if (_res) {
        let _result = _res.result
        if (_result === 0) {
          let info = _res.info
          if (!info) return
          let upgrade = this.upgrade = info.upgrade
          if (upgrade === 0) {
            this.version = info.version
            this.isUpdate = false
            this.updateText = '已是最新版本'
          } else if (upgrade === 1 || upgrade === 3) {
            this.version = info.version
            this.newVersion = info.new_version
            this.isUpdate = false
            this.updateText = '已预约升级'
          } else if (upgrade === 2) {
            this.version = info.version
            this.newVersion = info.new_version
            this.isUpdate = true
            this.updateText = '有新版本'
          }
        } else if (_result === 1) {
          this.isUpdate = false
        }
      }
    },
    getVersionInfoError (error) {
      this.toast.hide()
      console.log(error)
    }
  },
  created () {
    Common.setTitle('版本升级')
    this.getVersionInfo()
  }
}
</script>
<style lang="stylus" scoped>
  .content
    /* padding-top 16px */
    .item
      height 45px
      line-height 45px
      padding 0 16px
      background #ffffff
      font-size 14px
      .middle
        display block
        width 39px
        height 17px
        line-height 18px
        text-align center
        border-radius 9px
        background #334f5f
        color #ffffff
        margin-left 10px
        margin-top 15px
</style>


// WEBPACK FOOTER //
// src/pages/VersonUpdate/VersonUpdate.vue